import { useId } from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'react-tooltip';
import { ICON_BUTTON_ICONS } from '../../buttons/IconButton';
import { SUPPORT_EMAIL } from '../../../utils/constants/subscription';

// TD-2119: Tooltip currently uses structural copy because /subscription-status
// does not yet expose weekly_used / weekly_limit / weekly_resets_at. Once those
// fields ship, swap the fallback/normal copy for the absolute weekly numbers
// per Confluence R1.
const CompanyTokensInfoIcon = ({ fallbackActive = false, onHold = false }) => {
  // React 18+ useId() returns colon-bracketed ids like ":r0:". The id attribute
  // accepts colons fine, but the CSS selector passed to react-tooltip's
  // anchorSelect needs them escaped — CSS.escape is the canonical fix.
  const anchorId = useId();
  const anchorSelector = `#${CSS.escape(anchorId)}`;

  let content;
  if (onHold) {
    content = (
      <>
        Total pool exhausted. AI features paused.
        <br />
        Contact sales: {SUPPORT_EMAIL}
      </>
    );
  } else if (fallbackActive) {
    content = (
      <>
        Weekly limit reached. Resets Monday.
        <br />
        Using Haiku 4.5 until then.
        <br />
        Total pool still available.
      </>
    );
  } else {
    content = (
      <>
        Weekly cap triggers model fallback.
        <br />
        Total pool exhaustion pauses AI features.
      </>
    );
  }

  return (
    <>
      <span
        id={anchorId}
        className="default-black-info-circle-wrap company-tokens-info-icon"
        aria-label="Token usage details"
      >
        <img src={ICON_BUTTON_ICONS.INFO_CIRCLE} alt="" />
      </span>
      <Tooltip
        anchorSelect={anchorSelector}
        variant="dark"
        place="bottom-center"
        opacity={1}
        multiline
        content={content}
      />
    </>
  );
};

CompanyTokensInfoIcon.propTypes = {
  fallbackActive: PropTypes.bool,
  onHold: PropTypes.bool
};

export default CompanyTokensInfoIcon;
